(function () {
  'use strict';

  var form = document.getElementById('SearchFacetForm');
  if (!form) return;

  var sort = form.querySelector('[data-search-sort]');
  if (sort) {
    sort.addEventListener('change', function (event) {
      if (!event.target.matches('input[name="sort_by"]')) return;
      var formData = new FormData(form);
      formData.set('sort_by', event.target.value);
      var url = new URL(form.getAttribute('action') || window.location.pathname, window.location.origin);
      url.search = new URLSearchParams(formData).toString();
      window.location.assign(url.toString());
    });
  }

  var facets = Array.prototype.slice.call(form.querySelectorAll('[data-search-facet]'));
  facets.forEach(function (facet) {
    facet.addEventListener('toggle', function () {
      if (!facet.open) return;
      facets.forEach(function (other) {
        if (other !== facet) other.open = false;
      });
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    facets.forEach(function (facet) { facet.open = false; });
  });
})();
